var REACT_RENDER_OP = 'ui.react.render';

var REACT_UPDATE_OP = 'ui.react.update';

var REACT_MOUNT_OP = 'ui.react.mount';

export { REACT_MOUNT_OP, REACT_RENDER_OP, REACT_UPDATE_OP };
//# sourceMappingURL=constants.js.map
